import {useEffect, useState} from 'react'
import {CopyToClipboard} from 'react-copy-to-clipboard'
import {toast} from 'react-toastify'
import ReactToPrint from 'react-to-print'
import {downloadExcel} from 'react-export-table-to-excel'
import {KTIcon} from '../../../../../../_metronic/helpers'
import {useQueryResponse} from '../core/QueryResponseProvider'
import {CSVDownload} from 'react-csv'
import jsPDF from 'jspdf'
import autoTable from 'jspdf-autotable'
import {useIntl} from 'react-intl'

const UsersToolButtons = ({printRef, setShow}) => {
  const intl = useIntl()

  const {filterUsers} = useQueryResponse()

  const [copy, setCopy] = useState({
    text: '',
    copied: false,
  })
  const [check, setCheck] = useState(false)

  useEffect(() => {
    setCopy((copy) => ({
      ...copy,
      text: [
        ...filterUsers.map((fu) => {
          return [
            fu?.id,
            `${fu?.employee?.firstname} ${fu?.employee?.lastname} ${fu?.employee?.father_name}`,
            `${fu?.work_experience_before_enterprise?.split(',')[0]} il ${
              fu?.work_experience_before_enterprise?.split(',')[1]
            } ay ${fu?.work_experience_before_enterprise?.split(',')[2]} gun`,
            `${fu?.work_experience_enterprise?.split(',')[0]} il ${
              fu?.work_experience_enterprise?.split(',')[1]
            } ay ${fu?.work_experience_enterprise?.split(',')[2]} gun`,
            `${fu?.general_work_experience?.split(',')[0]} il ${
              fu?.general_work_experience?.split(',')[1]
            } ay ${fu?.general_work_experience?.split(',')[2]} gun`,
          ]
        }),
      ]
        .flat(Infinity)
        .join('->'),
    }))
  }, [filterUsers])

  const csvData = [
    [
      'ID',
      intl.formatMessage({id: 'NSF'}),
      intl.formatMessage({id: 'PREVIOUS.WORK.EXPERIENCE'}),
      intl.formatMessage({id: 'WORKEXPERIENCE'}),
      intl.formatMessage({id: 'TOTAL.LENGTH.OF.SERVICE'}),
    ],
    ...filterUsers?.map((fu) => {
      return [
        fu?.id,
        `${fu?.employee?.firstname} ${fu?.employee?.lastname} ${fu?.employee?.father_name}`,
        `${fu?.work_experience_before_enterprise?.split(',')[0]} il ${
          fu?.work_experience_before_enterprise?.split(',')[1]
        } ay ${fu?.work_experience_before_enterprise?.split(',')[2]} gun`,
        `${fu?.work_experience_enterprise?.split(',')[0]} il ${
          fu?.work_experience_enterprise?.split(',')[1]
        } ay ${fu?.work_experience_enterprise?.split(',')[2]} gun`,
        `${fu?.general_work_experience?.split(',')[0]} il ${
          fu?.general_work_experience?.split(',')[1]
        } ay ${fu?.general_work_experience?.split(',')[2]} gun`,
      ]
    }),
  ]

  const header = [
    'ID',
    intl.formatMessage({id: 'NSF'}),
    intl.formatMessage({id: 'PREVIOUS.WORK.EXPERIENCE'}),
    intl.formatMessage({id: 'WORKEXPERIENCE'}),
    intl.formatMessage({id: 'TOTAL.LENGTH.OF.SERVICE'}),
  ]
  const body = [
    ...filterUsers?.map((fu) => {
      return [
        fu?.id,
        `${fu?.employee?.firstname} ${fu?.employee?.lastname} ${fu?.employee?.father_name}`,
        `${fu?.work_experience_before_enterprise?.split(',')[0]} il ${
          fu?.work_experience_before_enterprise?.split(',')[1]
        } ay ${fu?.work_experience_before_enterprise?.split(',')[2]} gun`,
        `${fu?.work_experience_enterprise?.split(',')[0]} il ${
          fu?.work_experience_enterprise?.split(',')[1]
        } ay ${fu?.work_experience_enterprise?.split(',')[2]} gun`,
        `${fu?.general_work_experience?.split(',')[0]} il ${
          fu?.general_work_experience?.split(',')[1]
        } ay ${fu?.general_work_experience?.split(',')[2]} gun`,
      ]
    }),
  ]

  const handleExportExcel = () => {
    downloadExcel({
      fileName: 'Work Experience',
      sheet: 'Work Experience',
      tablePayload: {
        header,
        body,
      },
    })
  }

  const handleColumnVisibilityModal = () => {
    setShow(true)
  }

  const handleExportPDFTable = () => {
    const doc = new jsPDF()

    autoTable(doc, {
      head: [
        [
          'ID',
          intl.formatMessage({id: 'NSF'}),
          intl.formatMessage({id: 'PREVIOUS.WORK.EXPERIENCE'}),
          intl.formatMessage({id: 'WORKEXPERIENCE'}),
          intl.formatMessage({id: 'TOTAL.LENGTH.OF.SERVICE'}),
        ],
      ],
      body: [
        ...filterUsers?.map((fu) => {
          return [
            fu?.id,
            `${fu?.employee?.firstname} ${fu?.employee?.lastname} ${fu?.employee?.father_name}`,
            `${fu?.work_experience_before_enterprise.split(',')[0]} il ${
              fu?.work_experience_before_enterprise.split(',')[1]
            } ay ${fu?.work_experience_before_enterprise.split(',')[2]} gun`,
            `${fu?.work_experience_enterprise.split(',')[0]} il ${
              fu?.work_experience_enterprise.split(',')[1]
            } ay ${fu?.work_experience_enterprise.split(',')[2]} gun`,
            `${fu?.general_work_experience.split(',')[0]} il ${
              fu?.general_work_experience.split(',')[1]
            } ay ${fu?.general_work_experience.split(',')[2]} gun`,
          ]
        }),
      ],
    })

    doc.save('work-expriences-infos.pdf')
  }

  return (
    <div className='d-flex flex-column justify-content-center align-items-center gap-2 mt-2'>
      <button
        type='button'
        className='btn btn-light-primary mx-auto w-75'
        data-kt-menu-trigger='click'
        data-kt-menu-placement='bottom-end'
      >
        <CopyToClipboard
          text={copy.text}
          style={{display: 'flex', justifyContent: 'center', width: '100%'}}
          onCopy={() => {
            setCopy({...copy, copied: true})
            toast.success('Copied')
          }}
        >
          <span>{intl.formatMessage({id: 'COPY'})}</span>
        </CopyToClipboard>
      </button>

      <ReactToPrint
        trigger={() => {
          return (
            <button
              type='button'
              className='btn btn-light-primary mx-auto w-75'
              data-kt-menu-trigger='click'
              data-kt-menu-placement='bottom-end'
            >
              {intl.formatMessage({id: 'PRINT'})}
            </button>
          )
        }}
        content={() => printRef.current}
      />

      <button
        type='button'
        className='btn btn-light-primary mx-auto w-75'
        data-kt-menu-trigger='click'
        data-kt-menu-placement='bottom-end'
        onClick={handleExportExcel}
      >
        <KTIcon iconName='exit-up' className='fs-2' />
        {intl.formatMessage({id: 'EXCEL'})}
      </button>
      <button
        type='button'
        className='btn btn-light-primary mx-auto w-75'
        data-kt-menu-trigger='click'
        data-kt-menu-placement='bottom-end'
        onClick={() => {
          setCheck(true)
          setTimeout(() => {
            setCheck(false)
          }, 1000)
        }}
      >
        <KTIcon iconName='exit-up' className='fs-2' />
        CSV
        {check && <CSVDownload data={csvData} separator={';'} enclosingCharacter={``} />}
      </button>
      <button
        type='button'
        className='btn btn-light-primary mx-auto w-75'
        data-kt-menu-trigger='click'
        data-kt-menu-placement='bottom-end'
        onClick={handleExportPDFTable}
      >
        <KTIcon iconName='exit-up' className='fs-2' />
        PDF
      </button>

      <button
        type='button'
        className='btn btn-light-primary mx-auto w-75'
        data-kt-menu-trigger='click'
        data-kt-menu-placement='bottom-end'
        onClick={handleColumnVisibilityModal}
      >
        {intl.formatMessage({id: 'COLUMN.VISIBILITY'})}
      </button>
    </div>
  )
}

export default UsersToolButtons
